module.exports = __webpack_public_path__ + "static/Cinzel-VariableFont_wght-d87bbff8d3b3fa4e5a357b6c4cdd1c6c.ttf";